import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pr-8 pl-8 pb-8" }
const _hoisted_2 = { class: "flex mt-10" }
const _hoisted_3 = { class: "flex flex-row border-l-8 font-bold border-infoColor text-infoColor" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "px-4 flex items-center text-2xl font-bold" }
const _hoisted_6 = { class: "text-infoColor shadow-md rounded-full border py-2 px-4 ml-4" }
const _hoisted_7 = { class: "flex mt-6" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "w-2/3" }
const _hoisted_10 = { class: "font-bold justify-start" }
const _hoisted_11 = { class: "font-bold text-gray-600 truncate" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "truncate" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("日期: ")
const _hoisted_16 = { class: "text-red-600" }
const _hoisted_17 = { class: "truncate" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("地點: ")
const _hoisted_19 = { class: "text-red-600" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("日期: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600 truncate" }, " 主持人未決議 ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("地點: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600 truncate" }, " 主持人未決議 ")
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "w-1/3 text-right font-bold" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdPerson = _resolveComponent("MdPerson")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_grid_item = _resolveComponent("n-grid-item")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_ParticipantModal = _resolveComponent("ParticipantModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupHeaders, (status) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: status.Value
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(status.Name), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.eventData.filter((e) => e.Status == status.Value).length), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_n_grid, { cols: "1 640:2 768:3 1024:4" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.filter((e) => e.Status == status.Value), (event) => {
                  return (_openBlock(), _createBlock(_component_n_grid_item, {
                    key: event.EventID
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex flex-row border-4 rounded-lg mr-2 mb-2 p-4 cursor-pointer duration-700", _ctx.blockClass(event.Status, event.HasReply)]),
                        onClick: ($event: any) => (_ctx.onOpenModal(event.EventHeaderId))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            (status.Value != _ctx.ParamEventStatus.Open)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" 回覆率 " + _toDisplayString(_ctx.percentage(event.ResponseCount, event.HeadCount) + "%"), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.statusData.find(
                      (s) =>
                      s.Value ==
                      (event.HasReply == _ctx.ParamHasReply.Yes
                      ? _ctx.ParamEventStatus.Close
                      : _ctx.ParamEventStatus.Open)
                      )?.Name ?? ""), 1)
                                ], 64))
                          ]),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(event.Title), 1),
                          (status.Value == _ctx.ParamEventStatus.Close)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                ( event.IsResolution == _ctx.ParamIsResolution.Done)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                      _createElementVNode("p", _hoisted_14, [
                                        _hoisted_15,
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.localdayjs( event.StartUTCDateTime ?? new Date().toISOString()).format("YYYY/MM/DD (ddd) HH:mm")), 1)
                                      ]),
                                      _createElementVNode("p", _hoisted_17, [
                                        _hoisted_18,
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(event.Location), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                ( event.IsResolution == _ctx.ParamIsResolution.NotYet)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_n_icon, { class: "text-xl align-text-top" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MdPerson)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(event.ResponseCount) + " / " + _toDisplayString(event.HeadCount), 1)
                            ])
                          ])
                        ])
                      ], 10, _hoisted_8)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ])
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_ParticipantModal, {
      showModal: _ctx.showModal,
      onModalClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = $event)),
      eventColor: _ctx.stringColor(_ctx.modalEventID, false),
      eventID: _ctx.modalEventID,
      statusHeaders: _ctx.groupHeaders
    }, null, 8, ["showModal", "eventColor", "eventID", "statusHeaders"])
  ], 64))
}